import React from 'react';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { useAppSelector } from 'src/app/hooks';

import ProfileMenu from './ProfileMenu';
import { useNavigate } from 'react-router-dom';

type TopbarProps = { handleDrawerToggle?: () => void };

export default function TopBar({ handleDrawerToggle }: TopbarProps) {
  const { isMobile, title, subTitle, usuaria } = useAppSelector((state) => state.page);
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
    // navigate(key ? `/${key}` : '/');
  };

  if (!usuaria) {
    return null;
  }

  return (
    <AppBar position="fixed" elevation={0} sx={{ paddingLeft: isMobile ? 0 : 5 }}>
      <Toolbar>
        {subTitle ? (
          <IconButton edge="start" color="inherit" aria-label="voltar" onClick={handleBack}>
            <ArrowBackIcon />
          </IconButton>
        ) : isMobile ? (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleDrawerToggle}
            sx={{ mr: 2 }}>
            <MenuIcon />
          </IconButton>
        ) : null}
        <Typography
          variant="h6"
          component="div"
          sx={{
            flexGrow: 1,
            textAlign: isMobile ? 'center' : 'left',
            fontWeight: 400,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'clip',
          }}>
          {subTitle ? `${subTitle} :: ` : ''}
          {title}
        </Typography>
        {!subTitle && <ProfileMenu />}
        {/* <IconButton
              edge="start"
              // color="inherit"
              color="primary"
              aria-label="menu"
              onClick={() => {}}
              sx={{ ml: 2 }}>
              <NotificationsNoneIcon />
            </IconButton> */}
      </Toolbar>
    </AppBar>
  );
}
